import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { integrationModel } from '~/models';
export class CardHandler {
    handleClick(route) {
        integrationModel.isLinked(this.integration) ? this.ui.goToPage(route) : this.ui.requestApiKey(this);
    }
    getActionText() {
        return integrationModel.isLinked(this.integration) ? 'Manage connection' : 'Connect';
    }
    async saveApiKey(apiKey) {
        await this.server.saveApiKey(apiKey);
        this.ui.refetchIntegrations();
    }
    constructor(ui, integration, server){
        _define_property(this, "ui", void 0);
        _define_property(this, "integration", void 0);
        _define_property(this, "server", void 0);
        this.ui = ui;
        this.integration = integration;
        this.server = server;
    }
}
